import { setStorageItem } from '@bifrost-platform/bifront-sdk-react-biholder';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import React, { useCallback } from 'react';
import styled from 'styled-components';
import IconArrow from '@/assets/icons/icon-arrow.svg';
import ImageV2 from '@/assets/images/image-v2.png';
import { LINK_VIP_BORROW } from '@/configs/link';
import Dialog, { Props as DialogProps } from './Dialog';
import OriginButton from './atom/Button';
import { FlexBox } from './atom/FlexBox';
import { StyledText } from './atom/Text';

export interface Props extends DialogProps {}

export const STORAGE_ID_V2_USER_DIALOG_CLOSED = 'v2UserDialogClosed';

const StyledDialog = styled(Dialog)`
  z-index: 99999;
`;
const Wrapper = styled(FlexBox)`
  max-width: 456px;
`;
const ImageContainer = styled(FlexBox)`
  align-items: center;
  height: 194.43px;
`;
const ImageWrapper = styled.div`
  position: absolute;
  margin: -70px -90px -100px -100px;
  z-index: -1;
`;
const Button = styled(OriginButton)`
  width: 100%;
`;
const IconNext = styled(IconArrow)`
  transform: rotate(270deg);
  margin-right: -${({ theme }) => theme.size.xxs};
`;

export default function V2UserDialog({ onCloseClick, ...props }: Props) {
  const { t } = useTranslation('dialog');

  const handleCloseClick = useCallback(() => {
    setStorageItem(STORAGE_ID_V2_USER_DIALOG_CLOSED, Date.now());
    onCloseClick?.();
  }, [onCloseClick]);

  return (
    <StyledDialog {...props} onCloseClick={handleCloseClick}>
      <Wrapper $flex $direction="column" $gap="xl">
        <StyledText
          as="p"
          $fontSize="xl"
          $fontWeight="bold"
          $textAlign="center"
        >
          {t('dialog:v2User:title')}
        </StyledText>
        <StyledText
          as="p"
          $fontSize="sm"
          $textAlign="center"
          $textColor="textGray"
        >
          {t('dialog:v2User:description')}
        </StyledText>
        <ImageContainer $flex $direction="column" $justify="center">
          <ImageWrapper>
            <Image src={ImageV2} alt="" width={608.75} height={541.25} />
          </ImageWrapper>
        </ImageContainer>
        <a target="_blank" rel="noreferrer" href={LINK_VIP_BORROW}>
          <Button
            $variant="primary"
            $padding={{
              x: 'md',
              y: 'md',
            }}
          >
            <StyledText $fontSize="lg" $fontWeight="bold">
              {t('dialog:v2User:button')}
            </StyledText>
            <IconNext />
          </Button>
        </a>
      </Wrapper>
    </StyledDialog>
  );
}
